/**
 * Wishlist Vue Component
 * ------------------------------------------------------------------------------
 * 
 * 
 */

import axios from 'axios'

import ListingProductItem from './listing-product-item'

import { storefrontRequestConfig } from '../utils/api'
import { transformProduct, multipleProductQuery } from '../utils/data'

export default {
	components: {
		ListingProductItem
	},

	data() {
		return {
			isLoading: false,
			isActive: false,
			parsedIds: [],
			products: []
		}
	},

	props: {
		currencyIso: {
			type: String,
			default: 'AUD'
		}
  	},

	created () {
		this.fetchProduct()
	},

	mounted() {
	},

	methods: {
		async fetchProduct () {
			try {
				this.isLoading = true

				const getProductIds = localStorage.getItem('iWishlistmain')
				await axios.post('/apps/iwish', { iwishlist: JSON.stringify(getProductIds), cId: window.theme.customerId })

				this.parsedIds = Object.entries(JSON.parse(getProductIds))

				const ids = this.parsedIds
					.map(pair => pair[1].length >= 1 ? `"${btoa(`gid://shopify/Product/${pair[0]}`)}"` : null)
					.filter(Boolean)

				const { data, status } = await axios
					.post(`https://${Shopify.shop}/api/graphql`, multipleProductQuery({ currency: this.currencyIso, ids }), storefrontRequestConfig)


				if(status === 200) {
					this.products = data.data.nodes.map(node => node && transformProduct(node)).filter(Boolean)
					

					console.log(this.products, 'product');
				}

			} catch (error) {
				console.log(error, 'Error in fetching storefront products')
			} finally {
				this.isLoading = false
			}

		},

		handleAddedToCart({id, event}) {
			const variantsToRemove = this.parsedIds.find(productId => productId[0] === id.toString())[1]

			if(variantsToRemove.length) {
				variantsToRemove.forEach(variantId => {
					iwish_remove(event, variantId.toString())
				})
			}
			
			this.products = this.products.filter(product => product.id !== id)
		},

		closeDropwdon() {
			this.isActive = false
		}
	}
};